import React from 'react'

const Jva_temp = () => {
    return (
        <div className='container'>
            <h1>Java Basic Syntax</h1>
            <p>A Java program is a collection of objects, and these objects communicate through method calls to each other to work together. Here is a brief discussion on the Classes and Objects, Method, Instance variables, syntax, and semantics of Java.</p>
            <p><strong>Basic terminologies in Java</strong></p>
            <p><strong>1.</strong> <strong>Object</strong>: The object is an instance of a class, have Behavior and state.</p>
            <ul>
                <li>Example: A car is an object whose <strong>states </strong>are: brand, colour, number-plate.</li>
            
            <li>Behavior<strong>:</strong> Running on the road.</li>
            </ul>
            <p><strong>2.</strong> <strong>Class</strong>: The class is a blueprint(plan) of class objects and status.</p>
            <ul>
                <li><strong>Example</strong>: Blueprint of the house is class.</li>
            </ul>
            <p><strong>3.</strong> <strong>Method</strong>: The behavior of an object is the method.</p>
            <br />
            <ul>
                <li><strong>Example</strong>: The fuel indicator indicates the amount of fuel left in the car.</li>
            </ul>
            <p><strong>4. Instance variables</strong>: Every object has its own unique set of instance variables. The state of an object is generally created by the values that are assigned to these instance variables.</p>
            <p><strong>Example: </strong>Steps to compile and run a java program in a console</p>
            <pre className='output'>javac NooB.java <br />
java NooB</pre>
<div class="containers">
    <div class="line number1 index0 alt2"><code class="keywords">public</code> <code class="keywords">class</code> <code
            class="plain">NooB &#123;&nbsp;</code></div>
    <div class="line number2 index1 alt1"><code class="undefined spaces">&nbsp;&nbsp;</code><code
            class="keywords">public</code> <code class="keywords">static</code> <code class="keywords">void</code> <code
            class="plain">main (String[] args) &#123;</code></div>
    <div class="line number3 index2 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">System.out.println(</code><code class="string">"NooB!"</code><code class="plain">);</code>
    </div>
    <div class="line number4 index3 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div>
    <div class="line number5 index4 alt2"><code class="plain">&#125;</code></div>
</div>
<div class="output"><strong>Output</strong> <br />
<pre>NooB!</pre></div>
<p><strong>Note: </strong>When the class is public, the name of the file should be the class name.</p>
<p><strong>The Basic Syntax:</strong></p>
<p><strong>1. Comments in Java</strong></p>
<p>There are three types of comments in Java.&nbsp;</p>
<p><strong>&nbsp;i. </strong>Single line Comment</p>
<pre className='output'>// System.out.println("NooB!");</pre> <br />
<p><strong>ii.</strong> Multi-line Comment</p>
<pre>/*
    System.out.println("NooB!"); <br />
    System.out.println("Mohit!"); <br />
*/</pre>
<p><strong>iii. </strong>Documentation Comment. <span>Also called </span>a<span> </span><strong>doc comment</strong><span>.</span></p>
<pre className='output'>/** documentation */</pre>
<p><strong>2. Program File Name</strong></p>
<p>The name of a program file should exactly match the class name with an extension of .<strong>java</strong>. The name of the file can be other names if the program does not have any public class. Assume you have a public class <strong>NooB</strong>.</p>
<pre>NooB.java // valid syntax <br />
<i>noob</i>.java // invalid syntax</pre>
<p><strong>3. Case Sensitivity</strong></p>
<p>Java is a case-sensitive language, which means that the identifiers <i><strong>AB, Ab, aB</strong></i>,<i><strong> </strong></i>and <i><strong>ab </strong></i>are different in Java.</p>
<pre className='output'>System.out.println("Krishan"); // valid syntax <br />
<i>s</i>ystem.out.println("Mohit"); // invalid syntax</pre>
<p><strong>4. Class Names</strong></p>
<p><strong>i.</strong> The first letter of the class should be in Uppercase</p>
<p><strong>ii. </strong>If several words are used to form a name of the class, each inner word’s first letter should be in Upper Case, <span>Underscore are allowed</span>.</p>
<pre className='output'>class MyJavaProgram    // valid syntax <br />
class myJavaProgram    // invalid syntax</pre>
<p><strong>5. public static void main(String [] args)</strong></p>
<p>Java program processing starts with the method main().</p>
<p><strong>6. Method Names</strong></p>
<p><strong>i. </strong>All the method names should start with a Lower Case letter.</p>
<p><strong>ii.</strong> If several words are used to form the name of the method, then each first letter of the inner word should be in Upper Case, Underscore are allowed. (This is allowed in java and please correct the below example as well both are correct syntax as per Java but as standard people follow lowercase first char in function name)</p>
<pre>public void employeeRecords() // valid syntax <br />
public void EmployeeRecords() // valid syntax</pre>
<p><strong>7. Identifiers in java</strong></p>
<p><strong>i. </strong>All identifiers can begin with a letter (<strong>A to Z</strong> or <strong>a to z</strong>) or an underscore <strong>_</strong>.</p>
<p><strong>ii. </strong>The first character of identifiers can have any combination of characters.</p>
<p><strong>iii. </strong>Most importantly identifiers are case-sensitive.</p>
<p><strong>iv.</strong> A keyword cannot be used as an identifier since it is a reserved word and has some special meaning.</p>
<pre className='output'>Legal identifiers: MinNumber, total, ak74, hello_world, $amount, _under_value <br />
Illegal identifiers: 74ak, -amount</pre>
<p><strong>8. White-spaces in Java</strong></p>
<p>A line containing only white-spaces, possibly with the comment, is known as a blank line, and the Java compiler totally ignores it.</p>
<p><strong>9. Access Modifiers: </strong>These modifiers control the scope of class and methods.</p>
<ul>
    <li style={{textAlign:'justify'}}><strong>Access Modifiers:</strong> default, public, protected, private</li>

<li style={{textAlign:'justify'}}><strong>Non-access Modifiers:</strong> final, abstract, strictfp</li>
</ul>
<p style={{textAlign:'justify'}}><strong>10. Java Keywords</strong></p>
<p style={{textAlign:'justify'}}><strong>Keywords or Reserved words</strong><span> are the words in a language that are used for some internal process or represent some predefined actions. These words are therefore not allowed to use as variable names or objects.&nbsp;</span></p>
<table>
    <tbody>
        <tr>
            <td>abstract</td>
            <td>assert</td>
            <td>boolean</td>
            <td>break</td>
        </tr>
        <tr>
            <td>byte</td>
            <td>case</td>
            <td>catch</td>
            <td>char</td>
        </tr>
        <tr>
            <td>class</td>
            <td>const</td>
            <td>continue</td>
            <td>default</td>
        </tr>
        <tr>
            <td>do</td>
            <td>double</td>
            <td>else</td>
            <td>enum</td>
        </tr>
        <tr>
            <td>extends</td>
            <td>final</td>
            <td>finally</td>
            <td>float</td>
        </tr>
        <tr>
            <td>for</td>
            <td>goto</td>
            <td>if</td>
            <td>implements</td>
        </tr>
        <tr>
            <td>import</td>
            <td>instanceof</td>
            <td>int</td>
            <td>interface</td>
        </tr>
        <tr>
            <td>long</td>
            <td>native</td>
            <td>new</td>
            <td>package</td>
        </tr>
        <tr>
            <td>private</td>
            <td>protected</td>
            <td>public</td>
            <td>return</td>
        </tr>
        <tr>
            <td>short</td>
            <td>static</td>
            <td>strictfp</td>
            <td>super</td>
        </tr>
        <tr>
            <td>switch</td>
            <td>synchronized</td>
            <td>this</td>
            <td>throw</td>
        </tr>
        <tr>
            <td>throws</td>
            <td>transient</td>
            <td>try</td>
            <td>void</td>
        </tr>
        <tr>
            <td>volatile</td>
            <td>while</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
        </tr>
    </tbody>
</table>

        </div>
    )
}

export default Jva_temp
